function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-row">
        <p>Gruvy Education - Practical AI training for K-12 school leaders.</p>
        <a href="https://gruvyeducation.com" target="_blank" rel="noreferrer">
          gruvyeducation.com
        </a>
      </div>
    </footer>
  );
}

export default Footer;
